import Skeleton from "@/components/skeleton/Skeleton";

export default function ContentSkeleton() {
	return (
		<>
			<div className="h-8" />
			<Skeleton className="w-full h-7 rounded" />
			<Skeleton className="w-full h-4 rounded mt-3" />
			<Skeleton className="w-full h-4 rounded mt-1" />

			<Skeleton className="w-1/5 h-6 rounded mt-8" />
			<Skeleton className="w-full h-9 rounded mt-2" />

			<Skeleton className="w-1/4 h-6 rounded mt-9" />
			<Skeleton className="w-full h-9 rounded mt-2" />

			<Skeleton className="w-1/3 h-6 rounded mt-10" />
			<Skeleton className="w-full h-9 rounded mt-2" />

			<Skeleton className="w-1/2 h-6 rounded mt-8" />
			<Skeleton className="w-full h-9 rounded mt-2" />

			<Skeleton className="w-full h-6 rounded mt-8" />
			<Skeleton className="w-full h-9 rounded mt-2" />
		</>
	);
}
